import { AdvancedSelect } from '@orobix/orobix-fe-components'
import { useTranslation } from 'react-i18next'

import { useTargetProductClassesData } from './useTargetProductClassesData'
import { targetProductClassesToOption } from './utils'

export interface CompatibilityCheckSelectProps {
  fieldName: string
  options: string[]
  id: string
}

const CompatibilityCheckSelect = ({
  fieldName,
  options,
  id,
}: CompatibilityCheckSelectProps) => {
  const { targetProductClasses } = useTargetProductClassesData(options)

  const toOption = targetProductClassesToOption()
  const { t } = useTranslation()

  return (
    <AdvancedSelect
      name={fieldName}
      id={id}
      label={fieldName}
      options={targetProductClasses ? targetProductClasses.map(toOption) : []}
      placeholder={t('No Label')}
      isClearable
    />
  )
}

export default CompatibilityCheckSelect
